// extracted by mini-css-extract-plugin
export default {"content":"ProjectsPage_content__jcLUC"};